$(function () {
    let route = $(location).attr('pathname') + '?';

    // ページングクリック時
    $('.page-link').click(function () {
      let page_num = $(this).data('page-num');
      route = setParams('page', page_num);
      window.location.href = route;
    });

  // 現在のURLのパラメータを遷移先のURLに追加
    function setParams(param, value) {
      let url = location.search.substring(1).split('&');
      let count = 1;

      $.each(url, function (index, val) {
        let key = val.split('=');

        if (key[0] === param) {
          return true;
        }
        if (param !== 'page' && key[0] === 'page') {
          // 並び順、表示件数の変更時はページ数をリセットする
          return true;
        }

        if (key[0] != '') {
          if (count === 1) {
            route = route + key[0] + '=' + key[1]
          } else {
            route = route + '&' + key[0] + '=' + key[1]
          }
        }

        count++;
      });

      // 既にパラメータがあるかどうか
      if (route.indexOf('=') >= 0) {
        route = route + '&' + param + '=' + value;
      } else {
        route = route + param + '=' + value;
      }

      return route;
    }

  });
